<script setup>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";

import mainTabletImg from "@/assets/images/projectsPage/main.png";
import lowerImg from "@/assets/images/projectsPage/lower.png";
import brImg from "@/assets/images/projectsPage/br.png";
import { onBeforeUnmount, onMounted } from "vue";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);

const props = defineProps({ upImg: String, middleImg: String });

let tl;

onMounted(() => {
  tl = gsap.timeline();

  tl.to(".tablet__wrapper", {
    scrollTrigger: {
      trigger: ".tablet__wrapper",
      start: "0% 57px",
      end: "100% 57px",
      pin: true,
      end: "+=2000",
      // markers: true,
    },
  });
  tl.fromTo(
    ".tablet-img__up",
    { xPercent: -50, yPercent: -50, scale: 1 },
    {
      scrollTrigger: {
        trigger: ".tablet__wrapper",
        start: "0% 20%",
        end: "2000px 20%",
        scrub: 1,
        // markers: true,
      },
      xPercent: -50,
      yPercent: -80,
      scale: 0.75,
    }
  );
  tl.fromTo(
    ".tablet-img__middle",
    { xPercent: -50, yPercent: -50, scale: 1 },
    {
      scrollTrigger: {
        trigger: ".tablet__wrapper",
        start: "0% 20%",
        end: "2000px 20%",
        scrub: 1,
        // markers: true,
      },
      xPercent: -50,
      yPercent: -65,
      scale: 0.9,
    }
  );
  tl.fromTo(
    ".tablet-img__lower",
    { xPercent: -50, yPercent: -50, scale: 1 },
    {
      scrollTrigger: {
        trigger: ".tablet__wrapper",
        start: "0% 20%",
        end: "2000px 20%",
        scrub: 1,
        // markers: true,
      },
      xPercent: -50,
      yPercent: -50,
      scale: 1,
    }
  );
  tl.fromTo(
    ".tablet-img__main",
    { xPercent: -50, yPercent: -50, scale: 1 },
    {
      scrollTrigger: {
        trigger: ".tablet__wrapper",
        start: "0% 20%",
        end: "2000px 20%",
        scrub: 1,
        // markers: true,
      },
      xPercent: -50,
      yPercent: -50,
      scale: 1,
    }
  );
  tl.fromTo(
    ".tablet__container",
    { scale: 1 },
    {
      scrollTrigger: {
        trigger: ".tablet__wrapper",
        start: "0% 20%",
        end: "2000px 20%",
        scrub: 1,
        // markers: true,
      },

      scale: 1.2,
    }
  );
});

onBeforeUnmount(() => {
  tl.kill();
  tl = null;
});
</script>

<template>
  <div class="tablet__wrapper">
    <img class="tablet__br" :src="brImg" alt="" />
    <div class="tablet__container">
      <img class="tablet-img__main" :src="mainTabletImg" alt="" />
      <img class="tablet-img__lower" :src="lowerImg" alt="middleImg" />
      <img class="tablet-img__middle" :src="middleImg" alt="" />
      <img class="tablet-img__up" :src="upImg" alt="" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tablet__wrapper {
  position: relative;
  width: 100%;
  height: 100vh;

  overflow: hidden;
}
.tablet__br {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
}
.tablet__container {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
}
.tablet-img__main,
.tablet-img__lower,
.tablet-img__middle,
.tablet-img__up {
  position: absolute;
  top: 50%;
  left: 50%;

  width: 70%;
}
</style>
